module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/blog-9648e61bf34dc25b5875ffc56220be6f.jpg";